/* tslint:disable */
/* eslint-disable */
/**
 * REST API for AWV-UI
 * AWV-UI向けのREST APIリファレンス  ## Version履歴 - 1.0:2023/4/28 初版作成 - 1.1:2023/6/30   - すべてのAPIリファレンスを一つにまとめた   - Suspend Task→Cancel Taskに名前を変更   - 認証開始　削除   - トークン更新　認証処理の見直しにより全体修正   - タスク取得　レスポンスのユーザ名をユーザIDに変更、タスク状態修正   - Awrs→Awvsに修正   - 完成機情報取得　レスポンスに「カメラ仕様」「名称ID」追加、パラメータに車台形式・番号追加   - Go Home Task　レスポンスのtaskIDをjobsetId修正   - 以下API新規追加     - WebRTC配信設定     - WebRTC接続情報取得     - WebRTCユーザー設定     - パスワードリセット     - アンロックアカウント実行     - アンロックアカウントメール送信 - 1.2:2023/7/28   - 地図情報取得　パラメータのinをpathに修正   - タスク作成状況確認　パラメータの指定方法修正   - UnlockAccountResponseStatus204のref先変更   - 全APIにoperationId付与   - Skip Task　エラーレスポンス追加   - Cancel Task　エラーレスポンス追加   - プロジェクト一覧取得　レスポンスにジョブサイト名追加　400エラー削除   - トークン更新　レスポンスの204を削除し200を追加。レスポンスにemail、roleNameを追加   - タスク取得　レスポンス、リクエストパラメータ修正   - 完成機情報取得　正常レスポンス(200)の応答をobject形式に修正。処理概要に完成機1台分の情報取得の旨追記   - タスク作成状況確認　正常レスポンス(200)の応答をobject形式に修正   - タスク更新　リクエストをリクエストボディに変更し内容を修正。レスポンス修正   - タスク取得　正常レスポンス(200)の応答をobject形式に修正   - タスク名一覧取得　正常レスポンス(200)の応答をobject形式に修正   - WebRTC配信設定情報　正常レスポンス(200)の応答をobject形式に修正   - タスク登録　リクエストパラメータの内容修正   - タスク削除　リクエストパラメータの内容修正   - タスク作成状況確認　タスク作成時の409エラーを追加   - API設計方針追記 及び伴うエラーコードレスポンスをstringに修正   - マップ503エラーレスポンスの説明を500から503に修正   - 地図更新確認　リクエストパラメータの内容修正。200レスポンスの内容修正。204レスポンス削除。   - タスク登録　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク更新　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク名一覧取得　経由ノードのリストと、from地点ノードでの停止時間をレスポンスに追加。   - タスク取得　パラメータの必須かどうかを修正。経路情報取得の要否削除。レスポンスの必須かどうかを修正。   - タスク名一覧取得　レスポンス名をキャメルケースに修正し、配列でなくした。   - タスク承認　リクエストパラメータをキャメルケースに修正   - タスク取得　リクエストパラメータに「再計算タスク取得フラグ」を追加。レスポンスの必須かどうかを修正。   - WebRTC接続情報取得　レスポンスパラメータから「日時」を削除。「webRTC配信の停止」のパラメータ名を修正   - タスク作成状況確認　 レスポンスパラメータ名を修正 jobsetStatus → jobSetStatus   - Go Home Task、Cancel Task、Skip Taskを一つのタグにまとめた。   - パラメータ等にrequireで存在しないものが指定されているのを修正   - ResistTaskDataをRegisterTaskDataに修正   - 交通状況編集　レスポンス内容をバージョンIDのみに修正。204削除。   - Go Home Task実行 リクエストパラメータの日時情報候補リスト削除し、fromノードIDと開始希望日時追加。 - 1.3:2023/9/29   - Go Home Task実行　パラメータのrequireを修正   - WebRTC配信設定　「WebRTC解像度」と「WebRTCフレームレート」をrequireから外した   - 地図情報取得　レスポンスの地図情報の内容修正。204レスポンス削除。レスポンスに作成日時、更新日時、作成ユーザを追加。   - 交通状況編集　パラメータの地図情報をエッジ更新情報に修正   - 完成機情報取得　パラメータのgeoSiteId→jobSiteIdに修正。204レスポンス削除。   - usersに属するAPIから、AUTHORIZATIONS:PermissionTokenを削除   - タスク取得　Dateをdateにし、型も修正。レスポンスの「タスク実行予定時刻」の名称を「タスク実行予定時間（分）」に修正。レスポンスの経路情報にノードの到着時間と出発時間を追加。JobInfosの内部的な仕様修正。画面表示用タスクIDの例のスペル修正。レスポンスのバージョンIDに説明追加。   - 通知一覧取得　APIの説明文修正。パラメータの取得上限数の説明文修正、requireに指定、範囲を1～500に指定。レスポンスの通知情報内容修正。レスポンスに「車台形式・番号」追加404エラー追加。レスポンスに画面表示用タスクID追加。   - 通知既読　削除。   - 通知更新確認　APIの説明文修正。レスポンスの最新通知情報において、該当するイベントが0件だった場合未設定(null)とする旨を説明に追記及びレスポンスに「車台形式・番号」追加。レスポンスに画面表示用タスクID追加。   - プロジェクト一覧取得　ソートして返却する旨を記載   - トークン更新　レスポンスに名前、名字を追加   - jobsetStatus → jobSetStatusに修正   - メモ設定のpatternに空白文字追加 及び 1個以上ではなく0個以上に一致するよう修正   - タスク登録　パラメータのextensionTimeLoadをrequiredから外し、説明文を修正   - タスク更新　パラメータのextensionTimeLoadをrequiredから外した。   - タスク承認　リクエストボディをリスト化。   - タスク名一覧取得　JobInfosの内部的な仕様修正。extensionTimeLoadをrequiredから外した。   - WebRTCユーザー設定　200レスポンスを204に修正。   - WebRTC接続情報取得 200レスポンスの説明文修正。 - 1.4:2023/10/24   - 交通状況編集のレスポンスに最適化対象ジョブセットIDリストを追加   - タスク取得のパラメータに最適化対象ジョブセットIDリストを追加 - 1.4.1:2023/10/31   - タスク取得(一括承認用)APIを追加し、タスク取得APIから該当パラメータを削除 - 1.4.2:2023/11/08   - タスク取得(一括承認用)APIのリクエストパラメータを最適化対象ジョブセットIDからオブジェクトに修正   - 交通状況編集のレスポンスの最適化対象ジョブセットIDからオブジェクトに修正   - タスク取得APIのリクエストパラメータの地図バージョンを削除 - 1.4.3:2024/01/10   - タスク取得APIのレスポンスに移動タスク生成フラグを追加   - タスク登録APIのリクエストパラメータにタスク補完設定(移動タスク生成フラグ)を追加   - タスク取得APIのリクエストパラメータに承認待ちタスクのみ取得するフラグを追加   - 完成機情報取得のレスポンスの内容修正(conditionに「OTA中」を追加)   - 完成機情報取得のレスポンスに自律走行可否を追加 - 1.4.4:2024/01/23   - タスク取得のリクエストパラメータにパスデータを取得するか否かのフラグを追加   - タスク取得のレスポンスに経由パスのリストを追加   - プロジェクト一覧取得APIのレスポンスに地理サイト名と{ジョブサイトID, ジョブサイト名}を追加   - 地図情報取得APIのリクエストパラメータをジョブサイトIDから地図IDに変更   - 地図一覧取得APIを追加 - 1.4.5:2024/02/15   - 地図情報取得のレスポンスタイプMapEdgeTypeにoneWayを追加 - 1.5:2024/03/06   - 緊急停止実行APIを追加 - 1.6:2024/10/04   - 荷物情報取得APIを追加   - 充電器情報取得APIを追加 - 1.7:2024/10/17   - 充電運行計画のタスク登録APIを追加   - 充電運行計画のタスク更新APIを追加   - 充電運行計画のタスク取得APIを追加   - 充電運行計画のタスク名一覧取得APIを追加 - 1.8:2024/10/22   - ユーザー一覧取得APIを追加   - プロジェクト一覧取得のレスポンスに組織ID追加   - 充電運行計画のタスク名一覧取得のリクエストパラメータにinputDateを追加 - 1.8.1:2024/10/25   - 充電運行計画のタスク登録のリクエストパラメータにendDatetimeを追加   - 充電運行計画のタスク更新のリクエストパラメータにendDatetimeを追加 - 1.8.2:2024/11/07   - 充電運行計画のタスク名一覧取得のリクエストパラメータにjobSetIdを追加 - 1.8.3:2024/11/11   - 充電運行計画のタスク名一覧取得のレスポンスのjobInfosにjobIdを追加 - 1.8.4:2024/11/18   - 充電運行計画のタスク取得のレスポンスにバージョンIDを追加   - 充電運行計画のタスク名一覧取得のレスポンスにバージョンIDを追加 - 1.8.5:2024/11/21   - 充電運行計画のタスク登録／更新リクエストのジョブ終了希望日時のパラメータ名を修正 - 1.8.6:2024/11/22   - 充電運行計画のタスク取得のレスポンスに荷物数量を追加 - 1.8.7:2024/11/28   - 充電運行計画のタスク取得のレスポンスのjobPlanningEndDatetimeをrequiredから外した。  ## API設計方針 - 要求仕様: [API設計ガイドライン](https://hndx-gh-ex01.rd.honda.co.jp/OPPF-2X-DEV-COMMON-COMPONENTS/requirements/blob/master/api/api_design_guideline.md) - Description は APIの概要の記載にとどめ、初期値といった Swagger で用意されている記載方法がある場合はそれに則る書き方にする。 - OP-PFからのエラーレスポンスコードがある場合はintgerからstringに変換して返す。  上記を設計原則とするが、例外となるものは明記する。  ## Deprecated APIについて OP-PF AWV-UIにおいて、初期に利用されていたAPIをDeprecatedとして明示している。 - 新規での利用はしないこと。 - 実装のメンテナンスは行われず、テスト対象にもしない。 - 将来的に実装は取り除かれ、API仕様からも削除される 
 *
 * The version of the OpenAPI document: 1.8.6
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface ConfigurationParameters {
    basePath?: string; // override base path
    fetchApi?: FetchAPI; // override for fetch implementation
    middleware?: Middleware[]; // middleware to apply before/after fetch requests
    queryParamsStringify?: (params: HTTPQuery) => string; // stringify function for query strings
    username?: string; // parameter for basic security
    password?: string; // parameter for basic security
    apiKey?: string | Promise<string> | ((name: string) => string | Promise<string>); // parameter for apiKey security
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string | Promise<string>); // parameter for oauth2 security
    headers?: HTTPHeaders; //header params we want to use on every request
    credentials?: RequestCredentials; //value for the credentials param we want to use on each request
}

export class Configuration {
    constructor(private configuration: ConfigurationParameters = {}) {}

    set config(configuration: Configuration) {
        this.configuration = configuration;
    }

    get basePath(): string {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }

    get fetchApi(): FetchAPI | undefined {
        return this.configuration.fetchApi;
    }

    get middleware(): Middleware[] {
        return this.configuration.middleware || [];
    }

    get queryParamsStringify(): (params: HTTPQuery) => string {
        return this.configuration.queryParamsStringify || querystring;
    }

    get username(): string | undefined {
        return this.configuration.username;
    }

    get password(): string | undefined {
        return this.configuration.password;
    }

    get apiKey(): ((name: string) => string | Promise<string>) | undefined {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : async () => apiKey;
        }
        return undefined;
    }

    get accessToken(): ((name?: string, scopes?: string[]) => string | Promise<string>) | undefined {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : async () => accessToken;
        }
        return undefined;
    }

    get headers(): HTTPHeaders | undefined {
        return this.configuration.headers;
    }

    get credentials(): RequestCredentials | undefined {
        return this.configuration.credentials;
    }
}

export const DefaultConfig = new Configuration();

/**
 * This is the base class for all generated API classes.
 */
export class BaseAPI {

	 private static readonly jsonRegex = new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i');
    private middleware: Middleware[];

    constructor(protected configuration = DefaultConfig) {
        this.middleware = configuration.middleware;
    }

    withMiddleware<T extends BaseAPI>(this: T, ...middlewares: Middleware[]) {
        const next = this.clone<T>();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }

    withPreMiddleware<T extends BaseAPI>(this: T, ...preMiddlewares: Array<Middleware['pre']>) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware<T>(...middlewares);
    }

    withPostMiddleware<T extends BaseAPI>(this: T, ...postMiddlewares: Array<Middleware['post']>) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware<T>(...middlewares);
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    protected isJsonMime(mime: string | null | undefined): boolean {
        if (!mime) {
            return false;
        }
        return BaseAPI.jsonRegex.test(mime);
    }

    protected async request(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction): Promise<Response> {
        const { url, init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && (response.status >= 200 && response.status < 300)) {
            return response;
        }
        throw new ResponseError(response, 'Response returned an error code');
    }

    private async createFetchParams(context: RequestOpts, initOverrides?: RequestInit | InitOverrideFunction) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }

        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach(key => headers[key] === undefined ? delete headers[key] : {});

        const initOverrideFn =
            typeof initOverrides === "function"
                ? initOverrides
                : async () => initOverrides;

        const initParams = {
            method: context.method,
            headers,
            body: context.body,
            credentials: this.configuration.credentials,
        };

        const overriddenInit: RequestInit = {
            ...initParams,
            ...(await initOverrideFn({
                init: initParams,
                context,
            }))
        };

        const init: RequestInit = {
            ...overriddenInit,
            body:
                isFormData(overriddenInit.body) ||
                overriddenInit.body instanceof URLSearchParams ||
                isBlob(overriddenInit.body)
                    ? overriddenInit.body
                    : JSON.stringify(overriddenInit.body),
        };

        return { url, init };
    }

    private fetchApi = async (url: string, init: RequestInit) => {
        let fetchParams = { url, init };
        for (const middleware of this.middleware) {
            if (middleware.pre) {
                fetchParams = await middleware.pre({
                    fetch: this.fetchApi,
                    ...fetchParams,
                }) || fetchParams;
            }
        }
        let response: Response | undefined = undefined;
        try {
            response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
        } catch (e) {
            for (const middleware of this.middleware) {
                if (middleware.onError) {
                    response = await middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined,
                    }) || response;
                }
            }
            if (response === undefined) {
              if (e instanceof Error) {
                throw new FetchError(e, 'The request failed and the interceptors did not return an alternative response');
              } else {
                throw e;
              }
            }
        }
        for (const middleware of this.middleware) {
            if (middleware.post) {
                response = await middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone(),
                }) || response;
            }
        }
        return response;
    }

    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    private clone<T extends BaseAPI>(this: T): T {
        const constructor = this.constructor as any;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
};

function isBlob(value: any): value is Blob {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}

function isFormData(value: any): value is FormData {
    return typeof FormData !== "undefined" && value instanceof FormData;
}

export class ResponseError extends Error {
    override name: "ResponseError" = "ResponseError";
    constructor(public response: Response, msg?: string) {
        super(msg);
    }
}

export class FetchError extends Error {
    override name: "FetchError" = "FetchError";
    constructor(public cause: Error, msg?: string) {
        super(msg);
    }
}

export class RequiredError extends Error {
    override name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export type FetchAPI = WindowOrWorkerGlobalScope['fetch'];

export type Json = any;
export type HTTPMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'HEAD';
export type HTTPHeaders = { [key: string]: string };
export type HTTPQuery = { [key: string]: string | number | null | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery };
export type HTTPBody = Json | FormData | URLSearchParams;
export type HTTPRequestInit = { headers?: HTTPHeaders; method: HTTPMethod; credentials?: RequestCredentials; body?: HTTPBody };
export type ModelPropertyNaming = 'camelCase' | 'snake_case' | 'PascalCase' | 'original';

export type InitOverrideFunction = (requestContext: { init: HTTPRequestInit, context: RequestOpts }) => Promise<RequestInit>

export interface FetchParams {
    url: string;
    init: RequestInit;
}

export interface RequestOpts {
    path: string;
    method: HTTPMethod;
    headers: HTTPHeaders;
    query?: HTTPQuery;
    body?: HTTPBody;
}

export function exists(json: any, key: string) {
    const value = json[key];
    return value !== null && value !== undefined;
}

export function querystring(params: HTTPQuery, prefix: string = ''): string {
    return Object.keys(params)
        .map(key => querystringSingleKey(key, params[key], prefix))
        .filter(part => part.length > 0)
        .join('&');
}

function querystringSingleKey(key: string, value: string | number | null | undefined | boolean | Array<string | number | null | boolean> | Set<string | number | null | boolean> | HTTPQuery, keyPrefix: string = ''): string {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
            .join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) {
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    }
    if (value instanceof Object) {
        return querystring(value as HTTPQuery, fullKey);
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}

export function mapValues(data: any, fn: (item: any) => any) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}

export function canConsumeForm(consumes: Consume[]): boolean {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}

export interface Consume {
    contentType: string;
}

export interface RequestContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
}

export interface ResponseContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    response: Response;
}

export interface ErrorContext {
    fetch: FetchAPI;
    url: string;
    init: RequestInit;
    error: unknown;
    response?: Response;
}

export interface Middleware {
    pre?(context: RequestContext): Promise<FetchParams | void>;
    post?(context: ResponseContext): Promise<Response | void>;
    onError?(context: ErrorContext): Promise<Response | void>;
}

export interface ApiResponse<T> {
    raw: Response;
    value(): Promise<T>;
}

export interface ResponseTransformer<T> {
    (json: any): T;
}

export class JSONApiResponse<T> {
    constructor(public raw: Response, private transformer: ResponseTransformer<T> = (jsonValue: any) => jsonValue) {}

    async value(): Promise<T> {
        return this.transformer(this.raw.status === 204 ? await undefined : await this.raw.json());
    }
}

export class VoidApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<void> {
        return undefined;
    }
}

export class BlobApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<Blob> {
        return await this.raw.blob();
    };
}

export class TextApiResponse {
    constructor(public raw: Response) {}

    async value(): Promise<string> {
        return await this.raw.text();
    };
}
